module.exports = __webpack_public_path__ + "static/media/Imagine the Adventure.b05fba08.jpg";